import React from 'react';
import { ArtistSchema, ReleaseSchema } from '../../../types/schema';
import { ReleaseTile } from '../molecules/ReleaseTile';
import { style } from 'typestyle';
import { horizontal, wrap } from 'csstips';
import { percent, px } from 'csx';
import { spacing } from '../../../theme/spacing';
import { ReleaseArtwork } from '../molecules/ReleaseArtwork';
import { mediaLargeTabletOnly } from '../utilities/mediaQueries';

interface ReaseSidebarProps {
  artist: ArtistSchema;
  release: ReleaseSchema;
  otherReleases?: ReleaseSchema[];
}

const styles = {
  artwork: style({
    maxWidth: px(392),
    margin: '0 auto',
  }),
  contentSection: style({}),
  releases: style(
    {
      display: 'grid',
      gridTemplate: 'auto / repeat(2, 1fr)',
      width: percent(100),
      gap: spacing.DEFAULT,
    },
    mediaLargeTabletOnly({
      gridTemplateColumns: 'repeat(3, 1fr)',
    })
  ),
};

export const ReleaseSidebar: React.FC<ReaseSidebarProps> = ({ release, artist, otherReleases }) => {
  return (
    <>
      <ReleaseArtwork release={release} className={styles.artwork} />

      {otherReleases && otherReleases.length > 0 && (
        <div className={styles.contentSection}>
          <h3>{`More releases by ${artist.name}`}</h3>
          <div className={styles.releases}>
            {otherReleases.map((release) => (
              <ReleaseTile key={release.identity} release={release} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
